/*@ngInject*/
const AdvancedFilterMediator = function (filterRepository) {

    this.getFilters = function (type) {
        return filterRepository.getFilters(type);
    };

    this.getFilterTemplates = function (templateId) {
        return filterRepository.getFilterTemplates(templateId);
    };

    this.saveFilter = function (filter) {
        return filterRepository.saveFilter(filter);
    };

    this.deleteFilter = function (filter) {
        return filterRepository.deleteFilter(filter.uri);
    };

    this.getFilter = function (filterUri) {
        return filterRepository.getFilter(filterUri);
    };
};

angular.module('umCore')
    .service('advancedFilterMediator', AdvancedFilterMediator);
